import Immutable from "immutable";

export const status = {
  CLOSED: "closed",
  PREPARING: "preparing",
  PENDING: "pending",
  PROCESSING: "processing",
  COMPLETED: "completed"
}

export const Checkout = new Immutable.Record({
  status: status.CLOSED,
  schoolID: null,
  transactionID: null,
  totalToPay: null,
  error: null,
  errorCode: null
}, "Checkout");

Checkout.status = status;
export default Checkout;



// WEBPACK FOOTER //
// ./src/state/school_money/entities/Checkout.js